import { apiFetch } from './client';

export interface IvrSummary {
  total_calls: number;
  unique_callers: number;
  total_minutes: number;
}

export interface NodeHitRow {
  node_id: string;
  node_name: string | null;
  node_type: string;
  hits: number;
  unique_callers: number;
  avg_duration_ms: number | null;
  total_duration_ms: number | null;
}

export interface AnalyticsCallRow {
  id: string;
  started_at: string;
  ended_at: string | null;
  duration_ms: number | null;
  from_number: string | null;
  to_number: string | null;
  caller_id: string | null;
  tree_id: string | null;
  end_reason: string | null;
  hangup_cause: string | null;
}

export interface CallNodePathRow {
  id: string;
  seq: number;
  node_id: string;
  node_type: string;
  node_name: string | null;
  entered_at: string;
  exited_at: string | null;
  duration_ms: number | null;
  exit_reason: string | null;
  dtmf_input: string | null;
}

export interface CallsListResponse {
  rows: AnalyticsCallRow[];
  next_cursor: string | null;
}

export interface CallDetailResponse {
  call: AnalyticsCallRow;
  path: CallNodePathRow[];
}

export interface AnalyticsFilter {
  tree_id?: string;
  from?: string;
  to?: string;
  customer_id?: string;
}

function toQs(p: Record<string, unknown>): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) {
    if (v !== undefined && v !== null && v !== '') q.set(k, String(v));
  }
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const analytics = {
  ivrSummary: (f: AnalyticsFilter = {}) =>
    apiFetch<IvrSummary>(`/api/analytics/ivr-summary${toQs({ ...f })}`),

  nodeHits: (f: AnalyticsFilter = {}) =>
    apiFetch<{ rows: NodeHitRow[] }>(`/api/analytics/node-hits${toQs({ ...f })}`),

  calls: (f: AnalyticsFilter & { limit?: number; cursor?: string } = {}) =>
    apiFetch<CallsListResponse>(`/api/analytics/calls${toQs({ ...f })}`),

  call: (id: string) =>
    apiFetch<CallDetailResponse>(`/api/analytics/calls/${id}`),
};
